// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_id-a";
export var fulfillmentFormRail = "_id-9";
export var headerTitleRow = "_id-c";
export var orderDetailsWrapper = "_id-7";
export var orderLinkTrigger = "_id-2";
export var paymentInformationGrid = "_id-h";
export var paymentSummaryColumn = "_id-i";
export var shipmentContainer = "_id-b";
export var shipmentDetailsMainPane = "_id-8";
export var shipmentNavigationCard = "_id-5";
export var shipmentNavigationRail = "_id-3";
export var shipmentNavigationRailHeader = "_id-4";
export var shipmentSummaryFact = "_id-e";
export var shipmentSummaryGrid = "_id-d";
export var shipmentSummaryMetadataRow = "_id-f";
export var shipmentSummaryTags = "_id-g";
export var shipmentWorkspace = "_id-0";
export var shipmentWorkspaceContent = "_id-6";
export var shipmentWorkspaceHeader = "_id-1";